module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_8004.de5e2cb2.png";